/** Ortak biçimlendirme yardımcıları — dashboard, listeler ve ödeme ekranlarında paylaşılır. */

/** Tutarı ₺ ve 2 ondalık ile biçimler. String veya number kabul eder. */
export function money(v: string | number): string {
  return `₺${Number(v).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

/** Kısa tarih+saat (ör. "5 Tem 14:30") — dashboard ve son işlemler tablosu. */
export function fmtDate(d: string): string {
  return new Date(d).toLocaleString('tr-TR', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
}

/** Tarihi ayrı gün/saat parçalarına böler (liste hücreleri için). */
export function dCell(d: string): { date: string; time: string } {
  const dt = new Date(d);
  return {
    date: dt.toLocaleDateString('tr-TR', { day: 'numeric', month: 'short', year: 'numeric' }),
    time: dt.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' }),
  };
}

/** Banka görsel meta verisi (renk + baş harf). */
export const BANK_META: Record<string, { color: string; ini: string }> = {
  qnb: { color: '#7c3aed', ini: 'Q' },
  akbank: { color: '#dc2626', ini: 'A' },
  isbankasi: { color: '#0a2540', ini: 'İ' },
  yapikredi: { color: '#005c9e', ini: 'Y' },
  garanti: { color: '#00a94f', ini: 'G' },
};

/** Bankanın renk + baş harfini döner; bilinmeyen için mavi + ilk harf. */
export function bankMeta(key: string | null): { color: string; ini: string } {
  return (key && BANK_META[key]) || { color: '#2563eb', ini: (key || '?')[0].toUpperCase() };
}

/** Banka anahtarı → düzgün görünen ad (tablolar/modal). */
export const BANK_LABELS: Record<string, string> = {
  qnb: 'QNB Finansbank',
  akbank: 'Akbank',
  isbankasi: 'İş Bankası',
  yapikredi: 'Yapı Kredi',
  garanti: 'Garanti',
};

/** Banka anahtarına karşılık düzgün ad; bilinmeyende anahtarı büyük harf gösterir. */
export function bankLabel(key: string | null | undefined): string {
  return (key && BANK_LABELS[key]) || (key ? key.toUpperCase() : '—');
}
